
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7760"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7760"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kwsLS", function(module, exports) {

$parcel$export(module.exports, "appendChild", () => $9933fa0791667377$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "elm", () => $9933fa0791667377$export$be2543d304cb151);
$parcel$export(module.exports, "anchor", () => $9933fa0791667377$export$2e2992790a6f69a8);
$parcel$export(module.exports, "listItem", () => $9933fa0791667377$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "div", () => $9933fa0791667377$export$159d9494db57879b);
const $9933fa0791667377$export$1b8e57c9ea42f1d2 = (base)=>(child)=>{
        if (typeof child === 'string') {
            const node = document.createTextNode(child);
            base.appendChild(node);
            return node;
        } else {
            base.appendChild(child);
            return child;
        }
    };
const $9933fa0791667377$var$wrap = (childOrChildren)=>{
    if (Array.isArray(childOrChildren)) return childOrChildren;
    else return [
        childOrChildren
    ];
};
const $9933fa0791667377$export$be2543d304cb151 = (tagName)=>(childOrChildren, attributes = {})=>{
        const base = document.createElement(tagName);
        const append = $9933fa0791667377$export$1b8e57c9ea42f1d2(base);
        for (const [key, value] of Object.entries(attributes))base.setAttribute(key, value);
        const children = $9933fa0791667377$var$wrap(childOrChildren);
        children.map(append);
        return base;
    };
const $9933fa0791667377$export$407448d2b89b1813 = $9933fa0791667377$export$be2543d304cb151('a');
const $9933fa0791667377$export$a943aa9a0fca3f0b = $9933fa0791667377$export$be2543d304cb151('h2');
const $9933fa0791667377$export$2e2992790a6f69a8 = (href, childOrChildren, classList)=>$9933fa0791667377$export$407448d2b89b1813(childOrChildren, {
        href: href,
        class: classList?.join(' ')
    });
const $9933fa0791667377$export$76c7e83ecc9cdf05 = $9933fa0791667377$export$be2543d304cb151('li');
const $9933fa0791667377$export$159d9494db57879b = $9933fa0791667377$export$be2543d304cb151('div');

});

parcelRegister("g7sg5", function(module, exports) {

$parcel$export(module.exports, "fetchRooms", () => $43b6484f09870183$export$4f0e9c535f1bb59e);
$parcel$export(module.exports, "iframeURI", () => $43b6484f09870183$export$edf32c9699aea0c8);
$parcel$export(module.exports, "viewerURI", () => $43b6484f09870183$export$e1c46df012b3c18f);
$parcel$export(module.exports, "castURI", () => $43b6484f09870183$export$d81c481d4f3e4d55);
$parcel$export(module.exports, "attendURI", () => $43b6484f09870183$export$3ca68680512a07ae);

var $5kyO6 = parcelRequire("5kyO6");

var $gYii9 = parcelRequire("gYii9");

var $8PUzc = parcelRequire("8PUzc");
const $43b6484f09870183$export$4f0e9c535f1bb59e = async ()=>{
    try {
        const before = Date.now();
        const fetchResponse = await fetch(`/api/stream?${(0, $5kyO6.nanoid)()}`, {
            credentials: 'include'
        });
        const rooms = await fetchResponse.json();
        if (rooms.ok === false) {
            if (fetchResponse.status === 403) throw new (0, $8PUzc.AccessDenied)(rooms.error, fetchResponse.status);
            throw new Error(rooms.error);
        }
        const r = rooms.rooms.map((room)=>({
                id: room.id,
                name: room.title
            }));
        const totalTime = Date.now() - before;
        console.log(`[Rooms] Got rooms in ${totalTime}ms`, rooms);
        return (0, $gYii9.success)(r);
    } catch (err) {
        return (0, $gYii9.failure)(err);
    }
};
const $43b6484f09870183$export$edf32c9699aea0c8 = (id)=>`dynamic.html?id=${encodeURIComponent(id)}&v=${(0, $5kyO6.nanoid)()}`;
const $43b6484f09870183$export$e1c46df012b3c18f = (id)=>`all.html?only=${encodeURIComponent(id)}&v=${(0, $5kyO6.nanoid)()}`;
const $43b6484f09870183$export$d81c481d4f3e4d55 = (id)=>`cast.html?id=${encodeURIComponent(id)}&v=${(0, $5kyO6.nanoid)()}`;
const $43b6484f09870183$export$3ca68680512a07ae = (id, playerOverride = 'play.html')=>`${playerOverride}?stream=${encodeURIComponent(id)}&v=${(0, $5kyO6.nanoid)()}`;

});
parcelRegister("5kyO6", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $3e19d1f48674edf3$export$ac4959f4f1338dfc);

var $4yhkT = parcelRequire("4yhkT");
let $3e19d1f48674edf3$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $3e19d1f48674edf3$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let safeByteCutoff = 256 - 256 % alphabet.length;
    if (safeByteCutoff === 256) {
        let mask = alphabet.length - 1;
        return (size = defaultSize)=>{
            if (!size) return '';
            let id = '';
            while(true){
                let bytes = getRandom(size);
                let j = size;
                while(j--){
                    id += alphabet[bytes[j] & mask];
                    if (id.length >= size) return id;
                }
            }
        };
    }
    let step = Math.ceil(409.6 * defaultSize / safeByteCutoff);
    return (size = defaultSize)=>{
        if (!size) return '';
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--)if (bytes[j] < safeByteCutoff) {
                id += alphabet[bytes[j] % alphabet.length];
                if (id.length >= size) return id;
            }
        }
    };
};
let $3e19d1f48674edf3$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$3e19d1f48674edf3$export$a5cee9e955a615e5(alphabet, size | 0, $3e19d1f48674edf3$export$4385e60b38654f68);
let $3e19d1f48674edf3$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $4yhkT.urlAlphabet)[bytes[size] & 63];
    return id;
};

});
parcelRegister("4yhkT", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", () => $3507c8f9e2ed4e9d$export$2b646eea95309f00);
let $3507c8f9e2ed4e9d$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});


parcelRegister("gYii9", function(module, exports) {

$parcel$export(module.exports, "failure", () => $0c491dd3a8a80e10$export$af2dba6db4e9e1f0);
$parcel$export(module.exports, "success", () => $0c491dd3a8a80e10$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "isFailure", () => $0c491dd3a8a80e10$export$4ece3b219cb1e8e7);
$parcel$export(module.exports, "successValue", () => $0c491dd3a8a80e10$export$d72aae0753935b5e);
const $0c491dd3a8a80e10$export$af2dba6db4e9e1f0 = (value)=>({
        ok: false,
        value: value
    });
const $0c491dd3a8a80e10$export$fe7c49d056ea1d88 = (value)=>({
        ok: true,
        value: value
    });
const $0c491dd3a8a80e10$export$4ece3b219cb1e8e7 = (value)=>value.ok === false;
const $0c491dd3a8a80e10$export$b0ac3e614a309be3 = (value)=>value.ok === true;
const $0c491dd3a8a80e10$export$d72aae0753935b5e = (input)=>input.value;

});

parcelRegister("8PUzc", function(module, exports) {

$parcel$export(module.exports, "AccessDenied", () => $3b0ee6e7fbd2702b$export$a2e740b8e5781e25);
class $3b0ee6e7fbd2702b$export$a2e740b8e5781e25 extends Error {
    constructor(message, code){
        super(message), this.code = code;
        this.name = 'AccessDenied';
    }
}

});



var $kwsLS = parcelRequire("kwsLS");

var $g7sg5 = parcelRequire("g7sg5");

var $8PUzc = parcelRequire("8PUzc");

var $gYii9 = parcelRequire("gYii9");
const $883e84f61d7f5418$var$run = async ()=>{
    const accessDenied = document.querySelector('div#access-denied');
    const loading = document.querySelector('div#loading');
    const offline = document.querySelector('div#offline');
    const roomList = document.getElementById('room-list');
    const appendChildToRoomList = (0, $kwsLS.appendChild)(roomList);
    const roomsResponse = await (0, $g7sg5.fetchRooms)();
    if ((0, $gYii9.isFailure)(roomsResponse)) {
        if (roomsResponse.value instanceof (0, $8PUzc.AccessDenied)) {
            accessDenied.classList.remove('hidden');
            loading.classList.add('hidden');
            return;
        }
        alert('Could not get rooms. Try again.');
        return;
    }
    const rooms = (0, $gYii9.successValue)(roomsResponse);
    const lastRoom = rooms[rooms.length - 1];
    if (lastRoom) {
        window.location.href = (0, $g7sg5.attendURI)(lastRoom.id, 'play-pyconau2026.html');
        return;
    }
    loading.classList.add('hidden');
    offline.classList.remove('hidden');
};
$883e84f61d7f5418$var$run().catch((err)=>console.error('Failed somewhere', err));


//# sourceMappingURL=attend-pyconau2026.860e3a9b.js.map
